var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrsFeatureAvatar',[_vm._l((_vm.cultivationData),function(ref,i){
var color = ref.color;
var polygons = ref.polygons;
return _vm._l((polygons),function(polygon,j){return _c('polygon',{key:("cultivation-" + i + "-" + j),attrs:{"fill":color,"points":polygon}})})}),(_vm.borderPolygons)?_vm._l((_vm.borderPolygons),function(polygon,i){return _c('polygon',{key:("border-" + i),attrs:{"stroke":"black","stroke-width":"4","fill":"transparent","points":polygon}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }